module.exports = __webpack_public_path__ + "img/img-hotels.6a267b4c.png";